import type { PositionResponse } from '@nora-monorepo/track-api-web-client';

export interface TrackProperties {
  callSign?: string;
  visibilityState?: TrackVisibilityState;
  symbolPackId?: string;
  symbolId?: string;
  deviceId?: string;
  sidc?: string;
  [key: string]: string | number | undefined;
}

export interface OpenLayersTrackProperties extends TrackProperties {
  fill_color: string;
  line_width: number;
  label_text: string;
}

export interface LastKnownTrack {
  position: PositionResponse;
  properties?: TrackProperties;
}

export enum TrackVisibilityState {
  Hidden = 'hidden',
  Visible = 'visible',
  Highlighted = 'highlighted',
}
